import React, { useState } from 'react';
import { Text, Label } from '../../../../atoms';
import { IoMdClose } from 'react-icons/io';

import { ReactSVG } from 'react-svg';
import SyncIcon from '../../../../../assets/images/sync.svg';

import { Tooltip, withStyles } from '@material-ui/core';

import {
    capitalizeFirst,
    formatDateRange,
    renderSpeaker,
    renderAddress,
    formatMeetingRecurrence,
    isMeetingEvent,
    getMeetingRecurrences,
    getMeetingCarried,
    CustomTooltip,
} from '../../helpers';

const ModalDetailsEvent = React.forwardRef(({ contentModal = {}, onClose }, ref) => {
    const isMeeting = isMeetingEvent(contentModal);
    const meetingRecurrences = getMeetingRecurrences(contentModal);
    const meetingCarried = getMeetingCarried(contentModal);

    const [openTooltip, setOpenTooltip] = useState(false);

    console.log('meetingRecurrences => ', meetingRecurrences);

    return (
        <div ref={ref} className="modalCalendarList">
            <div className="headerDetailsEvent">
                <Text component="h2" text={capitalizeFirst(contentModal.title)} />
                <IoMdClose onClick={onClose} />
            </div>
            {isMeeting ? (
                <div className="isMeeting">
                    <div className="isMeetingContainer">
                        {contentModal.meetingRecurrence && (
                            <CustomTooltip
                                title="Evento recorrente"
                                placement="top"
                                open={openTooltip}
                                onOpen={() => setOpenTooltip(true)}
                                onClose={() => setOpenTooltip(false)}
                                interactive={false}
                                enterDelay={400}
                                leaveDelay={0}
                            >
                                <span
                                    className="calendarEventIconWrapper"
                                    onMouseLeave={() => setOpenTooltip(false)}
                                    onClick={() => setOpenTooltip(false)}
                                >
                                    <ReactSVG src={SyncIcon} className="calendarEventIcon" />
                                </span>
                            </CustomTooltip>
                        )}
                        <Text component="p" text={formatDateRange(contentModal.startDate, contentModal.finishDate)} />
                        <div className="meetingLabels">
                            {meetingCarried && <Label className="meetingCarriedLabel" text={'REALIZADO'} />}
                            <Label
                                className="meetingTypeLabel"
                                text={capitalizeFirst(contentModal.meetingType.toLowerCase())}
                            />
                        </div>
                    </div>
                    {contentModal.speaker && renderSpeaker(contentModal.speaker)}
                    {contentModal.address && renderAddress(contentModal.address, contentModal.meetingType)}
                </div>
            ) : (
                <>
                    <Text component="p" text={`<b>Data: </b> ${contentModal.data}`} />
                </>
            )}
            {contentModal.tipo && <Text component="p" text={`<b>Tipo: </b> ${capitalizeFirst(contentModal.tipo)}`} />}

            {contentModal.url && (
                <p>
                    <b>Url: </b>
                    <a href={contentModal.url} target="_blank" rel="noopener noreferrer">
                        {contentModal.url}
                    </a>
                </p>
            )}

            {contentModal.descricao && (
                <Text component="p" text={`<b>Descrição: </b> ${capitalizeFirst(contentModal.descricao)}`} />
            )}

            {meetingRecurrences.length > 0 && (
                <div className="modal-meetings">
                    {meetingRecurrences.map((m, index) => (
                        <div key={m.idMeeting} className="meeting-row">
                            {m.meetingType && <Label text={capitalizeFirst(m.meetingType.toLowerCase())} />}

                            <div className="date-info">
                                <Text
                                    component="div"
                                    className="date-info-ref date-info-title"
                                    text={
                                        m.title
                                            ? m.title
                                            : m.meetingRecurrence && m.meetingRecurrence.title
                                            ? m.meetingRecurrence.title
                                            : capitalizeFirst(`Encontro ${index + 1}`)
                                    }
                                />
                                <Text
                                    component="div"
                                    className="date-info-ref date-info-range"
                                    text={formatDateRange(m.startDate, m.finishDate)}
                                />

                                {m.speaker ? (
                                    <div className="date-info-ref date-info-range">{renderSpeaker(m.speaker)}</div>
                                ) : (
                                    <></>
                                )}

                                {m.meetingRecurrence ? (
                                    <div className="date-info-ref meetingRecurrenceIco">
                                        <CustomTooltip title={'Evento recorrente'} placement="top">
                                            <ReactSVG
                                                beforeInjection={(svg) => {}}
                                                src={SyncIcon}
                                                alt=""
                                                className="calendarEventIcon"
                                            />
                                        </CustomTooltip>
                                        {formatMeetingRecurrence(m.meetingRecurrence, m.startDate)}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
});

export default ModalDetailsEvent;
